import { Base } from "../../framework/base";
import { totalTaskDataRowId } from "../consts";
import { TaskDataRowDataType, TaskDataRowTotalType, TaskLockingType, TaskRepetitionType, TaskVisibility } from "../enums";
import { Translations } from "../translations";
import { TaskDataRow } from "./taskDataRow";
import { TaskDataRowCol } from "./taskDataRowCol";
import { TaskTypeCol } from "./taskTypeCol";
import { TaskTypePage } from "./taskTypePage";
var TaskEditTypeItem = /** @class */ (function () {
    function TaskEditTypeItem(obj) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.taskRepetitionType = obj && obj.taskRepetitionType || TaskRepetitionType.NotRepeated;
        this.taskLockingType = obj && obj.taskLockingType || TaskLockingType.NoLocking;
        this.visibility = obj && obj.visibility || TaskVisibility.PrivateAndPublic;
        this.lineMultiselect = obj && obj.lineMultiselect || false;
        this.headerCols = Base.getTypedArray(obj ? obj.headerCols : null, TaskTypeCol);
        this.formCols = Base.getTypedArray(obj ? obj.formCols : null, TaskTypeCol);
        this.lineCols = Base.getTypedArray(obj ? obj.lineCols : null, TaskTypeCol);
        this.pages = Base.getTypedArray(obj ? obj.pages : null, TaskTypePage);
    }
    TaskEditTypeItem.prototype.getTitle = function () {
        return this.code;
    };
    TaskEditTypeItem.prototype.getHash = function () {
        return this.id + "#" + this.code;
    };
    TaskEditTypeItem.prototype.hasFilterColumns = function () {
        for (var i = 0; i < this.headerCols.length; i++) {
            if (this.headerCols[i].useInFilter) {
                return true;
            }
        }
        for (var i = 0; i < this.formCols.length; i++) {
            if (this.formCols[i].useInFilter) {
                return true;
            }
        }
        return false;
    };
    TaskEditTypeItem.prototype.isVisible = function (isPrivate) {
        return this.visibility === TaskVisibility.PrivateAndPublic || (isPrivate && this.visibility === TaskVisibility.Private || !isPrivate && this.visibility === TaskVisibility.Public);
    };
    TaskEditTypeItem.createTaskTypeCol = function (key, value, dataType, colIndex) {
        var result = new TaskTypeCol();
        result.dataType = dataType;
        result.field = key;
        result.title = !Base.isNullOrUndefined(value.title) ? value.title : "";
        result.required = !Base.isNullOrUndefined(value.required) && value.required;
        result.readOnly = !Base.isNullOrUndefined(value.readOnly) && value.readOnly;
        result.readOnlyExpression = !Base.isNullOrUndefined(value.readOnlyExpression) ? value.readOnlyExpression : "";
        result.class = !Base.isNullOrUndefined(value.class) ? value.class : "";
        result.unitTitle = !Base.isNullOrUndefined(value.unitTitle) ? value.unitTitle : "";
        result.expression = !Base.isNullOrUndefined(value.expression) ? value.expression : "";
        result.expressionFormat = !Base.isNullOrUndefined(value.expressionFormat) ? value.expressionFormat : "";
        result.expressionIndex = !Base.isNullOrUndefined(value.expressionIndex) ? value.expressionIndex : colIndex;
        result.defaultSortField = !Base.isNullOrUndefined(value.defaultSortField) && value.defaultSortField;
        result.defaultSortOrderAsc = !Base.isNullOrUndefined(value.defaultSortOrderAsc) && value.defaultSortOrderAsc;
        result.placeholder = !Base.isNullOrUndefined(value.placeholder) ? value.placeholder : "";
        result.defaultExpression = !Base.isNullOrUndefined(value.defaultExpression) ? value.defaultExpression : "";
        result.lineTotalType = !Base.isNullOrUndefined(value.lineTotalType) ? value.lineTotalType : TaskDataRowTotalType.None;
        result.lineTotalExpression = !Base.isNullOrUndefined(value.lineTotalExpression) ? value.lineTotalExpression : "";
        return result;
    };
    TaskEditTypeItem.getTaskTypeCol = function (key, value, isLineSchema, colIndex) {
        if (!key)
            return null;
        if (Base.isNullOrUndefined(value))
            return null;
        var result;
        var type = !Base.isNullOrUndefined(value.type) ? value.type : "";
        type = !Base.isNullOrEmpty(type) ? type : "";
        if (type.equalIgnoreCase("date") || type.equalIgnoreCase("time")) {
            result = TaskEditTypeItem.createTaskTypeCol(key, value, TaskDataRowDataType.Date, colIndex);
            if (type.equalIgnoreCase("time")) {
                result.dataType = TaskDataRowDataType.Time;
            }
            result.useInFilter = !Base.isNullOrUndefined(value.useInFilter) && value.useInFilter;
            result.defaultStr = !Base.isNullOrUndefined(value.default) ? value.default : "";
            return result;
        }
        if (type.equalIgnoreCase("integer") || type.equalIgnoreCase("boolean")) {
            result = TaskEditTypeItem.createTaskTypeCol(key, value, TaskDataRowDataType.Integer, colIndex);
            if (type.equalIgnoreCase("boolean")) {
                result.dataType = TaskDataRowDataType.Boolean;
                result.defaultStr = !Base.isNullOrUndefined(value.default) ? value.default : "";
            }
            else {
                result.defaultNbr = !Base.isNullOrUndefined(value.default) ? value.default : null;
            }
            result.minimum = !Base.isNullOrUndefined(value.minimum) ? value.minimum : null;
            result.maximum = !Base.isNullOrUndefined(value.maximum) ? value.maximum : null;
            result.useInFilter = !Base.isNullOrUndefined(value.useInFilter) && value.useInFilter;
            return result;
        }
        if (type.equalIgnoreCase("string")) {
            result = TaskEditTypeItem.createTaskTypeCol(key, value, TaskDataRowDataType.String, colIndex);
            result.defaultStr = !Base.isNullOrUndefined(value.default) ? value.default : "";
            result.maxLength = !Base.isNullOrUndefined(value.maxLength) ? value.maxLength : null;
            result.options = !Base.isNullOrUndefined(value.enum) ? value.enum : null;
            result.idOptions = !Base.isNullOrUndefined(value.idEnum) ? value.idEnum : null;
            result.useInFilter = !Base.isNullOrUndefined(value.useInFilter) && value.useInFilter;
            result.selectOptionsSubSectionValuesByTitle = !Base.isNullOrUndefined(value.selectOptionsSubSectionValuesByTitle) && value.selectOptionsSubSectionValuesByTitle;
            return result;
        }
        if (type.equalIgnoreCase("number") || type.equalIgnoreCase("timespan")) {
            result = TaskEditTypeItem.createTaskTypeCol(key, value, TaskDataRowDataType.Number, colIndex);
            if (type.equalIgnoreCase("timespan")) {
                result.dataType = TaskDataRowDataType.TimeSpan;
            }
            result.defaultNbr = !Base.isNullOrUndefined(value.default) ? value.default : null;
            result.minimum = !Base.isNullOrUndefined(value.minimum) ? value.minimum : null;
            result.maximum = !Base.isNullOrUndefined(value.maximum) ? value.maximum : null;
            result.decimals = !Base.isNullOrUndefined(value.decimals) ? value.decimals : 0;
            result.useInFilter = !Base.isNullOrUndefined(value.useInFilter) && value.useInFilter;
            return result;
        }
        if (type.equalIgnoreCase("signature")) {
            return TaskEditTypeItem.createTaskTypeCol(key, value, TaskDataRowDataType.Signature, colIndex);
        }
        if (!isLineSchema) {
            if (type.equalIgnoreCase("label")) {
                return TaskEditTypeItem.createTaskTypeCol(key, value, TaskDataRowDataType.Label, colIndex);
            }
            else if (type.equalIgnoreCase("lineBreak")) {
                return TaskEditTypeItem.createTaskTypeCol(key, value, TaskDataRowDataType.LineBreak, colIndex);
            }
            return null;
        }
        if (key.equalIgnoreCase("modifyUserName")) {
            result = TaskEditTypeItem.createTaskTypeCol(key, value, TaskDataRowDataType.String, colIndex);
            return result;
        }
        return null;
    };
    TaskEditTypeItem.getJsonTaskTypeColsToList = function (schema, isLineSchema) {
        var result = [];
        for (var prop in schema) {
            if (Object.prototype.hasOwnProperty.call(schema, prop)) {
                var taskTypeCol = TaskEditTypeItem.getTaskTypeCol(prop, schema[prop], isLineSchema, result.length);
                if (!Base.isNullOrUndefined(taskTypeCol)) {
                    result.push(taskTypeCol);
                }
            }
        }
        return result;
    };
    TaskEditTypeItem.getTaskTypeFromDataSchema = function (dataSchema, errorCallback) {
        var result = new TaskEditTypeItem();
        if (!dataSchema)
            return result;
        try {
            var obj = JSON.parse(dataSchema);
            if (Base.isNullOrUndefined(obj))
                return result;
            if (Object.prototype.hasOwnProperty.call(obj, "header") && !Base.isNullOrUndefined(obj.header)) {
                result.headerCols = TaskEditTypeItem.getJsonTaskTypeColsToList(obj.header, false);
            }
            if (Object.prototype.hasOwnProperty.call(obj, "form") && !Base.isNullOrUndefined(obj.form)) {
                result.formCols = TaskEditTypeItem.getJsonTaskTypeColsToList(obj.form, false);
            }
            if (Object.prototype.hasOwnProperty.call(obj, "line") && !Base.isNullOrUndefined(obj.line)) {
                result.lineCols = TaskEditTypeItem.getJsonTaskTypeColsToList(obj.line, true);
            }
        }
        catch (error) {
            errorCallback(error);
            return null;
        }
        return result;
    };
    TaskEditTypeItem.getTaskTypesByVisibility = function (taskTypes, isPublic) {
        return isPublic
            ? taskTypes.filter(function (i) { return i.visibility === TaskVisibility.Public || i.visibility === TaskVisibility.PrivateAndPublic; })
            : taskTypes.filter(function (i) { return i.visibility === TaskVisibility.Private || i.visibility === TaskVisibility.PrivateAndPublic; });
    };
    TaskEditTypeItem.getTaskTypeFromSchema = function (dataSchema) {
        var dataSchemaParseError = "";
        var taskType = TaskEditTypeItem.getTaskTypeFromDataSchema(dataSchema, function (error) {
            dataSchemaParseError = Base.isString(error)
                ? (error !== null && error !== void 0 ? error : "")
                : (error.message && Base.isString(error.message)
                    ? error.message
                    : JSON.stringify(error));
        });
        if (!taskType) {
            return {
                taskType: null,
                headerDataRow: null,
                formDataRow: null,
                lineDataRow: null,
                error: dataSchemaParseError,
            };
        }
        var headerDataRow = new TaskDataRow();
        headerDataRow.id = Base.getGuid();
        headerDataRow.cols = TaskDataRowCol.initializeValuesByType(taskType.headerCols, []);
        var formDataRow = new TaskDataRow();
        formDataRow.id = Base.getGuid();
        formDataRow.cols = TaskDataRowCol.initializeValuesByType(taskType.formCols, []);
        var lineDataRow = new TaskDataRow();
        lineDataRow.id = Base.getGuid();
        lineDataRow.cols = TaskDataRowCol.initializeValuesByType(taskType.lineCols, []);
        return {
            taskType: taskType,
            headerDataRow: headerDataRow,
            formDataRow: formDataRow,
            lineDataRow: lineDataRow,
            error: dataSchemaParseError
        };
    };
    TaskEditTypeItem.getTaskTypesForUiSelect = function (taskTypes, isPublic) {
        var filteredTaskTypes = TaskEditTypeItem.getTaskTypesByVisibility(taskTypes, isPublic);
        var notRepeatedTaskTypes = filteredTaskTypes.filter(function (i) { return i.taskRepetitionType !== TaskRepetitionType.Repeated; });
        var repeatedTaskTypes = filteredTaskTypes.filter(function (i) { return i.taskRepetitionType === TaskRepetitionType.Repeated; });
        var result = [];
        if (notRepeatedTaskTypes.length > 0) {
            result = [{ id: "NotRepeated", title: Translations.OneTimeForm, divider: true }];
            result = result.concat(notRepeatedTaskTypes.map(function (item) {
                return {
                    id: item.id,
                    title: item.code
                };
            }));
        }
        if (repeatedTaskTypes.length > 0) {
            result = result.concat([{ id: "Repeated", title: Translations.RowForm, divider: true }]);
            result = result.concat(repeatedTaskTypes.map(function (item) {
                return {
                    id: item.id,
                    title: item.code
                };
            }));
        }
        return result;
    };
    //#region Expression Evaluation
    TaskEditTypeItem.evaluateColsExpression = function (expression, typeCols, taskDataRowCols, errorCallback) {
        if (!expression)
            return null;
        var _loop_1 = function (i) {
            var dataCol = taskDataRowCols[i];
            var index = expression.indexOf(dataCol.field);
            if (index < 0)
                return "continue";
            var typeCol = typeCols.find(function (j) { return j.field === dataCol.field; });
            if (Base.isNullOrUndefined(typeCol))
                return "continue";
            var valueStr = "";
            if (typeCol.dataType === TaskDataRowDataType.String) {
                valueStr = !Base.isNullOrEmpty(dataCol === null || dataCol === void 0 ? void 0 : dataCol.valueStr) ? dataCol === null || dataCol === void 0 ? void 0 : dataCol.valueStr : "";
            }
            else if (typeCol.dataType === TaskDataRowDataType.Integer || typeCol.dataType === TaskDataRowDataType.Number || typeCol.dataType === TaskDataRowDataType.Boolean || typeCol.dataType === TaskDataRowDataType.TimeSpan) {
                valueStr = !Base.isNullOrUndefined(dataCol.valueNbr) ? dataCol.valueNbr.toString(10) : "0";
            }
            else if (typeCol.dataType === TaskDataRowDataType.Time) {
                valueStr = TaskDataRowCol.getTimeEvalValue(dataCol.valueNbr);
            }
            else if (typeCol.dataType === TaskDataRowDataType.Date) {
                valueStr = TaskDataRowCol.getDateEvalValue(dataCol.valueNbr);
            }
            expression = expression.replace(new RegExp(dataCol.field, "g"), valueStr);
        };
        for (var i = 0; i < taskDataRowCols.length; i++) {
            _loop_1(i);
        }
        try {
            /* eslint-disable no-eval */
            return eval(expression);
            /* eslint-enable no-eval */
        }
        catch (error) {
            errorCallback(error);
            return null;
        }
    };
    TaskEditTypeItem.evaluateColsExpressions = function (taskDataRowCols, typeCols, errorCallback) {
        if (errorCallback === void 0) { errorCallback = null; }
        var callback = errorCallback || (function (error) {
            console.log("evaluateColsExpressions", error);
        });
        if (taskDataRowCols.length < 1)
            return;
        var relevantTypeCols = typeCols.filter(function (i) { return !Base.isNullOrEmpty(i.expression); });
        if (relevantTypeCols.length < 1)
            return;
        TaskTypeCol.sortExpressionTaskTypeCols(relevantTypeCols);
        var expressionTaskDataRowCols = TaskDataRowCol.getExpressionFieldTaskDataRowCols(taskDataRowCols);
        var _loop_2 = function (i) {
            var typeCol = relevantTypeCols[i];
            var dataCol = expressionTaskDataRowCols.find(function (j) { return j.field === typeCol.field; });
            if (Base.isNullOrUndefined(dataCol))
                return "continue";
            var value = TaskEditTypeItem.evaluateColsExpression(typeCol.expression, typeCols, expressionTaskDataRowCols, callback);
            if (Base.isNullOrUndefined(value))
                return "continue";
            if (typeCol.dataType === TaskDataRowDataType.String) {
                dataCol.valueStr = value;
            }
            else {
                dataCol.valueNbr = value;
                dataCol.valueStr = TaskDataRowCol.getTaskDataRowColUiValue(typeCols.find(function (j) { return j.field === dataCol.field; }), dataCol === null || dataCol === void 0 ? void 0 : dataCol.valueStr, dataCol.valueNbr);
            }
        };
        for (var i = 0; i < relevantTypeCols.length; i++) {
            _loop_2(i);
        }
    };
    //#endregion Expression Evaluation
    //#region ReadOnly Expression Evaluation
    TaskEditTypeItem.evaluateColsReadOnlyExpressions = function (taskDataRowCols, typeCols, errorCallback) {
        if (errorCallback === void 0) { errorCallback = null; }
        var callback = errorCallback || (function (error) {
            console.log("evaluateColsReadOnlyExpressions", error);
        });
        var result = [];
        if (!taskDataRowCols || !typeCols || taskDataRowCols.length < 1 || typeCols.length < 1)
            return result;
        var relevantTypeCols = typeCols.filter(function (i) { return !Base.isNullOrEmpty(i.readOnlyExpression); });
        if (relevantTypeCols.length < 1)
            return result;
        TaskTypeCol.sortExpressionTaskTypeCols(relevantTypeCols);
        var expressionTaskDataRowCols = TaskDataRowCol.getExpressionFieldTaskDataRowCols(taskDataRowCols);
        var _loop_3 = function (i) {
            var typeCol = relevantTypeCols[i];
            var dataCol = expressionTaskDataRowCols.find(function (j) { return j.field === typeCol.field; });
            if (!dataCol)
                return "continue";
            var value = TaskEditTypeItem.evaluateColsExpression(typeCol.readOnlyExpression, typeCols, expressionTaskDataRowCols, callback);
            if (!value)
                return "continue";
            result.push(typeCol.field);
        };
        for (var i = 0; i < relevantTypeCols.length; i++) {
            _loop_3(i);
        }
        result.sort();
        return result;
    };
    //#endregion ReadOnly Expression Evaluation
    //#region Total Row
    TaskEditTypeItem.getTotalRowTaskEditTypeItem = function (taskType) {
        var result = new TaskEditTypeItem();
        result.id = taskType.id;
        var hasTotalCols = false;
        var _loop_4 = function (lineCol) {
            var formCol = taskType.formCols.find(function (i) { return i.field === lineCol.field; });
            if (!formCol)
                return "continue";
            if (lineCol.lineTotalType !== TaskDataRowTotalType.None) {
                hasTotalCols = true;
            }
            var col = new TaskTypeCol();
            col.dataType = lineCol.lineTotalType === TaskDataRowTotalType.None || lineCol.lineTotalType === TaskDataRowTotalType.Text
                ? TaskDataRowDataType.String
                : (lineCol.lineTotalType === TaskDataRowTotalType.LineCount
                    ? TaskDataRowDataType.Integer
                    : lineCol.dataType);
            col.field = lineCol.field;
            col.class = lineCol.class;
            col.decimals = formCol.decimals;
            col.defaultStr = lineCol.lineTotalType === TaskDataRowTotalType.Text
                ? lineCol.lineTotalExpression
                : "";
            col.expression = lineCol.lineTotalType === TaskDataRowTotalType.Expression
                ? lineCol.lineTotalExpression
                : "";
            col.lineTotalType = lineCol.lineTotalType === TaskDataRowTotalType.None || lineCol.lineTotalType === TaskDataRowTotalType.Text
                ? TaskDataRowTotalType.None
                : lineCol.lineTotalType;
            col.expressionFormat = lineCol.lineTotalType === TaskDataRowTotalType.None || lineCol.lineTotalType === TaskDataRowTotalType.Text
                ? ""
                : formCol.expressionFormat;
            result.formCols.push(col);
            result.lineCols.push(col);
        };
        for (var _i = 0, _a = taskType.lineCols; _i < _a.length; _i++) {
            var lineCol = _a[_i];
            _loop_4(lineCol);
        }
        if (!hasTotalCols) {
            result.formCols = [];
            result.lineCols = [];
        }
        return result;
    };
    TaskEditTypeItem.getTotalRow = function (totalTaskType, rows) {
        if (!totalTaskType || totalTaskType.lineCols.length === 0)
            return null;
        var result = new TaskDataRow();
        result.id = totalTaskDataRowId;
        result.cols = [];
        var colIndexes = rows.length > 0
            ? totalTaskType.lineCols.map(function (lc) { return rows[0].cols.findIndex(function (c) { return c.field === lc.field; }); })
            : [];
        var _loop_5 = function (i) {
            var totalCol = totalTaskType.lineCols[i];
            var col = new TaskDataRowCol();
            col.field = totalCol.field;
            col.valueNbr = 0;
            col.valueStr = totalCol.dataType === TaskDataRowDataType.String
                ? totalCol.defaultStr
                : "";
            if (totalCol.lineTotalType === TaskDataRowTotalType.LineCount) {
                col.valueNbr = rows.length;
                col.valueStr = col.valueNbr.toString();
            }
            else if (totalCol.lineTotalType === TaskDataRowTotalType.ColSum || totalCol.lineTotalType === TaskDataRowTotalType.ColAverage && rows.length > 0 && colIndexes[i] >= 0) {
                if (totalCol.dataType === TaskDataRowDataType.Integer ||
                    totalCol.dataType === TaskDataRowDataType.Number ||
                    totalCol.dataType === TaskDataRowDataType.TimeSpan ||
                    totalCol.dataType === TaskDataRowDataType.Date ||
                    totalCol.dataType === TaskDataRowDataType.Time) {
                    col.valueNbr = rows.reduce(function (a, row) { var _a; return a + ((_a = row.cols[colIndexes[i]].valueNbr) !== null && _a !== void 0 ? _a : 0); }, 0);
                    if (totalCol.lineTotalType === TaskDataRowTotalType.ColAverage) {
                        col.valueNbr = col.valueNbr / rows.length;
                    }
                    else if (totalCol.dataType === TaskDataRowDataType.Date ||
                        totalCol.dataType === TaskDataRowDataType.Time) {
                        col.valueNbr = 0;
                    }
                }
            }
            result.cols.push(col);
        };
        for (var i = 0; i < totalTaskType.lineCols.length; i++) {
            _loop_5(i);
        }
        TaskEditTypeItem.evaluateColsExpressions(result.cols, totalTaskType.formCols);
        return result;
    };
    return TaskEditTypeItem;
}());
export { TaskEditTypeItem };
